import React, { ChangeEvent } from "react";
import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";

import InputTextAreaStyles from "../styles/components/InputTextAreaStyles";

const { StyledFormControl, StyledLabel, StyledLengthInfo } =
    InputTextAreaStyles;

interface InputTextAreaProps {
    id?: string;
    label?: string;
    value: string;
    placeholder?: string;
    onChange?: (
        event: ChangeEvent<{
            value: unknown;
        }>
    ) => void;
    style?: CSSProperties;
    disabled?: boolean;
    maxLength?: number;
    viewLengthInfo?: boolean;
    clean?: boolean;
}

function InputTextArea({
    id,
    label,
    placeholder,
    value,
    onChange,
    style,
    disabled = false,
    maxLength,
    viewLengthInfo = true,
    clean = false,
}: InputTextAreaProps) {
    const cleanStyle = {
        borderRadius: "0",
        borderWidth: "0px 0px 1px 0px !important",
    };

    const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
        if (onChange && maxLength) {
            const eventValue = event.target.value as string;
            const shouldSetValue = eventValue.length < maxLength + 1;
            if (shouldSetValue) onChange(event);
        } else if (onChange) {
            onChange(event);
        }
    };

    return (
        <FormGroup controlId="exampleForm.ControlTextarea1">
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            <StyledFormControl
                id={id}
                as="textarea"
                rows={5}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                style={!clean ? style : Object.assign(cleanStyle, style)}
                disabled={disabled}
            />
            {viewLengthInfo && maxLength && (
                <StyledLengthInfo>
                    {value?.length}/{maxLength}
                </StyledLengthInfo>
            )}
        </FormGroup>
    );
}

export default InputTextArea;
